import { GET_G20_TRACKS } from '../constants/ActionTypes';

import config from '@plone/volto/registry';

export function getG20Tracks() {
  const { settings } = config;

  return {
    type: GET_G20_TRACKS,
    request: {
      op: 'get',
      path: `${settings.apiPath}/g20-api/tracks`,
    },
  };
}
